import {getVerification, requestVerificationAI, verificationList} from "../../api/ai/ai.api";
import {useEffect, useRef, useState} from "react";
import {Button, TextInput} from "omoplay";
import ArrowTop from "../../assets/images/icon.arrow.top.svg"
import ChatIcon from "../../assets/images/icon.chat_logo.svg"
import ReactMarkdown from 'react-markdown';

const AIVerification = () => {
    const [messages, setMessages] = useState([])
    const [verifications, setVerifications] = useState([])
    const [blockGenerate, setBlockGenerate] = useState(false)
    const [input, setInput] = useState("")
    const scrollRef = useRef(null)
    const [isCommandKeyPressed, setIsCommandKeyPressed] = useState(false)

    function setChatModelMessages(type, message) {
        setMessages((prevMessages) => [...prevMessages, {
            type: type,
            message: message
        }]);
    }

    useEffect(() => {
        verificationList().then(({data}) => {
            setVerifications(data.data)
        })
    }, []);

    const streamGeneration = (text, isText = true) => {
        setBlockGenerate(true)
        setInput("")
        // Enter 키를 누르면 메시지를 추가
        if (isText) {
            setChatModelMessages("user", text)
        }

        let curMessage = "요청 중입니다...<br/>";
        setChatModelMessages("model", curMessage)

        const eventSource = requestVerificationAI(text)

        eventSource.onmessage = (event) => {
            const data = event.data
            if (data.includes("AI_CHAT_END")) {
            } else if (data.includes("AI_CHAT_END_ALL")) {
                eventSource.close();
            } else {
                curMessage += data
                setMessages((prevMessages) => {
                    const updatedMessages = [...prevMessages];
                    updatedMessages[updatedMessages.length - 1] = {
                        type: "model",
                        message: curMessage
                    };
                    return updatedMessages;
                });
            }
        };

        eventSource.onerror = () => {
            setMessages((prevMessages) => {
                curMessage += "오류가 발생했습니다."
                const updatedMessages = [...prevMessages];
                updatedMessages[updatedMessages.length - 1] = {
                    type: "model",
                    message: curMessage
                };
                return updatedMessages;
            });
            eventSource.close();
        }
    }

    const handleChatKeyDown = (e) => {
        if (e.key === "Shift") {
            setIsCommandKeyPressed(true)
        }
    }

    const handleChatKeyUp = (e) => {
        if (e.key === "Enter" && !isCommandKeyPressed && input.trim() !== "" && !blockGenerate) {
            streamGeneration(input)
            return
        }

        if (e.key === "Shift") {
            setIsCommandKeyPressed(false)
        }
    }

    const handleChatSubmit = () => {
        if (input.trim() !== "" && !blockGenerate) {
            streamGeneration(input)
        }
    }

    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
    }, [messages]);

    return (
        <div className="flex">
            <div className="left-0 top-0 min-w-[300px] w-[300px] h-screen p-[36px] flex-col gap-4 overflow-scroll">
                <div className="text-[24px]">히스토리</div>
                {
                    verifications.map((verification) => {
                        return <div className="text-[14px] whitespace-nowrap text-ellipsis pointer"
                                    onClick={() => {
                                        getVerification(verification.id).then(({data}) => {
                                            const {prompt, contents, pdfUrl, recommendName} = data.data
                                            setBlockGenerate(true)
                                            const serviceNames = recommendName?.recommends?.map(recommend => {
                                                return `서비스명: ${recommend.serviceName}, 도메인: ${recommend.domains}, 사유: ${recommend.reason}`;
                                            }).join("<br/>")

                                            setMessages([{type: "user", message: prompt}])
                                            setChatModelMessages("model",
                                                `${contents}
                                                [PDF 파일 다운로드](${pdfUrl})
                                                ${serviceNames}`
                                            )
                                        })
                                    }}>
                            {verification.prompt}
                        </div>
                    })
                }
            </div>
            <div className="flex-1 flex-col bg-white border rounded-[8px]" style={{height: "calc(100vh - 80px)"}}>
                <div className="flex-col flex-1 justify-end w-full overflow-scroll">
                    <div className="flex-col gap-4 p-8 overflow-scroll" ref={scrollRef}>
                        {messages.map(({type, message}) => {
                            if (type === "model") {
                                return (
                                    <>
                                        <div className="flex gap-1">
                                            <img src={ChatIcon} alt="chat-logo" width="20" />
                                            <span className="text-primary font-medium">AI 메시지 봇</span>
                                        </div>
                                        <div className="ml-[20px] whitespace-pre-line">
                                            <ReactMarkdown>{message.replace(/<br\s*\/?>/gi, "\n")}</ReactMarkdown>
                                        </div>
                                    </>
                                )
                            } else {
                                return (
                                    <div className="flex justify-end">
                                        <div className="w-auto bg-depth1 p-20px rounded-[16px]">{message}</div>
                                    </div>
                                )
                            }
                        })}
                    </div>
                    <div className="flex p-[24px] border-t">
                        <div className="flex-1 gap-2">
                            <TextInput placeholder="AI에게 질문 해보세요."
                                       value={input}
                                       onChange={(e) => setInput(e.target.value)}
                                       onKeyDown={handleChatKeyDown}
                                       onKeyUp={handleChatKeyUp}
                                       style={{width: "100%", height: "68px"}}
                            />
                        </div>
                        <div className="relative flex-center-all">
                            <div className="absolute right-0 p-[24px]">
                                <Button disabled={blockGenerate} variants="rounded"
                                        value={<img alt="질문" src={ArrowTop} />}
                                        onClick={handleChatSubmit} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AIVerification